export const getLableMaxWidth = (totalWidth: number, percent: number) => {
  return Math.round((totalWidth / 100) * percent);
};
